<!--
  ~ ls-elements
  ~ Copyright (C) 2024 Libriciel SCOP
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. If not, see <http://www.gnu.org/licenses/>.
  -->

<div class="picker-container"
     [style.width]="size + 2 + 'px'">

  <div #picker class="picker"
       [style.height]="size + 'px'"
       (mousedown)="sqMouseDown($event)">

    <div #pointer class="pointer" [style.background-color]="color"></div>
  </div>

  <div class="slider-container">
    <div class="hue"
         (click)="changeHue($event)">
    </div>

    <div #slider
         class="slider"
         [class.notclicked]="!isDown"
         (mousedown)="hueMouseDown()">
    </div>
  </div>

  <div class="result-container">
    <span class="selected-color"
          [style.background-color]="color">
    </span>
    <input maxlength="7"
           #input
           pattern="#[A-Fa-f0-9]{6}"
           [(ngModel)]="color">
  </div>
</div>
